import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-form2',
  templateUrl: './report-form2.component.html',
  styleUrls: ['./report-form2.component.css']
})
export class ReportForm2Component implements OnInit {
  title="PSA Internal Security Division Form2 Report";
  constructor() { 
    this.show = false;
    this.show1 = false;
  }

  show:boolean;
  show1:boolean;
  ngOnInit() {

  }

  finalize(){
    this.show = true;
    this.show1 = false;
  }
  save(){
    this.show = false;
    this.show1 = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/report-form2/report-form2.component.ts